<template>
  <decor-card
    class="transaction-list"
    :space-content="false"
  >

    <template slot="headerLeft">
      <decor-hoz-stack
        align-middle
        type="1"
      >
      <div class="dataset-search-container">
          <dataset-search
            :dataset="$refs.dataset"
            v-if="datasetReady"
          ></dataset-search>
        </div>
        <div>
          <d-dataset-desc
            class="is-text-truncate is-size-7"
            :dataset="$refs.dataset"
            postfix="clients"
            v-if="datasetReady"
          />
        </div>
       
      </decor-hoz-stack>
      
    </template>
    <template slot="headerRight">
      <control-button
          class="is-outlined is-background-transparent is-small dangerBorder"
          v-if="exportData.length > 0"
          @click="deletePopUp"
          >Delete Select Clients</control-button
        >
    </template>

    <!-- <template slot="headerRight">

      <decor-hoz-stack
        type="1"
        align-middle
      >
        <div>
          <d-dataset-column
            :dataset="$refs.dataset"
            v-if="datasetReady"
          >
            <control-button
              class="is-primary is-tiny"
              button-style="4"
            >
              <decor-icon
                icon="list-ul"
                class="is-size-6"
              ></decor-icon>
            </control-button>
          </d-dataset-column>
        </div>
      </decor-hoz-stack>

    </template> -->

    <d-dataset
      class="dataset-transaction-list"
      ref="dataset"
      :config="listConfig"
      @ready="datasetReady = true"
      :store="$store"
      :checkedrows.sync="exportData"
    >
      <decor-icon-skeleton-anim
        size="150"
        slot="loading"
      />
    </d-dataset>

    <div class="dataset-foot-container">
      <d-dataset-foot
        :dataset="$refs.dataset"
        v-if="datasetReady"
      >  
      </d-dataset-foot>
    </div>

  </decor-card>
</template>

<script>
import store from '@/store'
import { modules } from '@/components/dataset-modules'
import { db, storage } from "@/module/firebase";
import { dangerBar, successBar, successToast} from "@/lib/notif";
import { DialogProgrammatic } from 'buefy';


export default {
  name: 'RequestList',
  components: {
    datasetSearch: modules.search
  },
  props:{
    clients: {type: Array, default: () => []},
    exportData: {type: Array, default: () => []}
  },
  data() {
    return {
      datasetReady: false,
      
      
    }
  },
  computed: {
    listConfig(){
      var config = require('./config').default;
      config.source = this.getClients
      return config
    }
  },
  methods: {
    async getClients(){
      const uid = store.state.searchClientsByUser.id;
      var result = await db.ref(`/clients/${uid}`).once("value");
      var clients = result.val() ? Object.values(result.val()) : [];
      this.$emit('setClients', clients)
      return clients;
    },
    deletePopUp() {
    
      if (this.exportData.length === 0) {
        dangerBar("You didn't choose any client");
        return;
      }
      else{
      DialogProgrammatic.confirm({
        message: `Are you sure you want to delete this clients?`,
        onConfirm: this.deleteClients,
        canCancel: true
      });
      }
    },
    async deleteClients() {
      try {
        const uid = store.state.searchClientsByUser.id;
        
        Promise.all(
          this.exportData.map(async client => {
          
            await db.ref(`/clients/${uid}/${client.id}`).remove();

          })

        );
        this.$emit('clearExport')
        successBar("Clients were deleted successfully");
        
       this.$refs.dataset.forceFetch();
    
      } catch (e) {
        console.log(e);
        dangerBar(e.message ? e.message : "There was an error");
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/style/inject";
.dangerBorder{
  border-color:red;
}
.dataset-transaction-list {
  padding: 0 1.5em;
}
.dataset-foot-container {
  border-top: $border 1px solid;
}
</style>
